import script from "./document-templates-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./document-templates-list-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__